import { useEffect } from 'react';

/**
 * FE-FIX08. Success-уведомления («Правило создано», «Зона сохранена») висели
 * на экране до перезагрузки страницы. Автозакрытие применяется только к ним:
 * сообщение об ошибке пользователь должен прочитать и закрыть сам.
 */
export const useAutoDismiss = (value, reset, ms = 4000) => {
  useEffect(() => {
    if (!value) return undefined;
    const timer = setTimeout(() => reset(''), ms);
    return () => clearTimeout(timer);
  }, [value, reset, ms]);
};

export default useAutoDismiss;
